// extracted by mini-css-extract-plugin
export default {"wrapper":"EQVisualizer_wrapper__V3-B6","canvas":"EQVisualizer_canvas__6SwJK"};